module.exports = __webpack_public_path__ + "img/switzerland-tuberculosis-male.a06dce04.png";